import { SET_DMX_PROFILE_CHANNELS, SET_DMX_PROFILE_CHANNELS_SUCCESSFUL, SET_DMX_PROFILE_CHANNELS_FAILED } from './actionTypes';

const initialState = {
  setDmxProfileChannelsError: null,
  messageDmxProfile: null,
  loadingSetDmxProfileChannels: false,
};

const setProfileChannels = (state = initialState, action) => {
  switch (action.type) {
    case SET_DMX_PROFILE_CHANNELS:
      state = { ...state, loadingSetDmxProfileChannels: true, setDmxProfileChannelsError: null };
      break;
    case SET_DMX_PROFILE_CHANNELS_SUCCESSFUL:
      state = { ...state, loadingSetDmxProfileChannels: false, messageDmxProfile: action.payload, setDmxProfileChannelsError: null };
      break;
    case SET_DMX_PROFILE_CHANNELS_FAILED:
      state = { ...state, messageDmxProfile: null, loadingSetDmxProfileChannels: false, setDmxProfileChannelsError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default setProfileChannels;
